import { createBrowserHistory, createMemoryHistory } from 'history'
import { get } from 'svelte/store'
import { baseUrl, currentRoute } from '../../stores/router'

const __BROWSER__ = typeof window !== 'undefined'

export const history = __BROWSER__ ? createBrowserHistory() : createMemoryHistory()

export function buildUrl(route, params) {
  let path = route.path
  for (const name in params) {
    path = path.replace(`:${name}`, params[name])
  }
  return `${get(baseUrl)}${path}`
}

export function navigate(route, params) {
  const url = buildUrl(route, params)
  history.push(url, { name: route.name, params })
  currentRoute.set({ name: route.name, params })
}

export function shouldNavigate(event) {
  return (
    !event.defaultPrevented &&
    event.button === 0 &&
    !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
  )
}
